import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Target, 
  Users, 
  Globe, 
  Network,
  BookOpen,
  MessageSquare,
  Lightbulb,
  TrendingUp,
  Award,
  CheckCircle,
  Calendar,
  Video,
  FileText,
  GraduationCap,
  ArrowRight
} from 'lucide-react';

const Proyectos = () => {
  const caracteristicasForo = [
    {
      titulo: 'Movilización de inteligencia colectiva',
      descripcion: 'Experiencia de la red UNESCO de Cátedras y redes UNITWIN de Iberoamérica',
      icon: Lightbulb
    },
    {
      titulo: 'Debates interdisciplinarios',
      descripcion: 'Intercambio sobre cuestiones emergentes del desarrollo sostenible',
      icon: MessageSquare
    },
    {
      titulo: 'Mandato UNESCO',
      descripcion: 'Educación, cultura, comunicación y ciencias',
      icon: BookOpen
    },
    {
      titulo: 'Agenda ONU',
      descripcion: 'Cuestiones amplias para las Naciones Unidas',
      icon: Globe
    }
  ];

  const objetivosForo = [
    'Ampliar los límites del conocimiento sobre temas relacionados con el mandato de la UNESCO',
    'Fomentar debates interdisciplinarios y multidisciplinarios',
    'Crear una plataforma abierta para el debate, colaboración e intercambio de conocimientos',
    'Ampliar la cooperación para abordar las cuestiones acuciantes de nuestro tiempo',
    'Reunir a investigadores, sociedad civil, profesionales y especialistas'
  ];

  const tiposParticipantes = [
    { tipo: 'Cátedras UNESCO', icon: GraduationCap, color: 'blue' },
    { tipo: 'Redes UNITWIN', icon: Network, color: 'purple' },
    { tipo: 'Investigadores', icon: BookOpen, color: 'green' },
    { tipo: 'Sociedad Civil', icon: Users, color: 'orange' },
    { tipo: 'Profesionales', icon: Award, color: 'teal' },
    { tipo: 'Especialistas', icon: Target, color: 'red' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0077C8] via-[#005A9C] to-[#004B87] text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-6">
          {/* Logos Header */}
          <div className="bg-gradient-to-br from-white/95 to-white/90 rounded-2xl p-6 md:p-8 shadow-lg border border-white/30 mb-12 relative overflow-hidden backdrop-blur-sm">
            <div className="absolute inset-0 bg-gradient-to-r from-[#0077C8]/5 via-transparent to-[#0077C8]/5"></div>
            <div className="relative flex flex-col md:flex-row items-center justify-center gap-8 md:gap-10">
              {/* Logo Foro Iberoamericano */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img 
                    src="https://catedra-unesco.cenid.org/images/logo_foro.jpg" 
                    alt="Logo Foro Iberoamericano" 
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">Foro Iberoamericano</span>
              </div>

              {/* Separator 1 */}
              <div className="flex items-center justify-center">
                <div className="hidden md:flex flex-col items-center gap-2">
                  <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-400 to-transparent"></div>
                  <div className="bg-[#0077C8] p-2 rounded-full shadow-lg">
                    <Globe className="w-5 h-5 text-white" />
                  </div>
                  <div className="w-px h-12 bg-gradient-to-b from-gray-400 via-transparent to-transparent"></div>
                </div>
                <div className="md:hidden w-32 h-px bg-gradient-to-r from-transparent via-gray-400 to-transparent"></div>
              </div>

              {/* Logo UNESCO */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img 
                    src="http://catedra-unesco.cenid.org/images/unesco.png" 
                    alt="Logo UNESCO" 
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">UNESCO</span>
              </div>

              {/* Separator 2 */}
              <div className="flex items-center justify-center">
                <div className="hidden md:flex flex-col items-center gap-2">
                  <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-400 to-transparent"></div>
                  <div className="bg-[#0077C8] p-2 rounded-full shadow-lg">
                    <BookOpen className="w-5 h-5 text-white" />
                  </div>
                  <div className="w-px h-12 bg-gradient-to-b from-gray-400 via-transparent to-transparent"></div>
                </div>
                <div className="md:hidden w-32 h-px bg-gradient-to-r from-transparent via-gray-400 to-transparent"></div>
              </div>

              {/* Logo Proyecto Cátedra */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img 
                    src="https://recursos.cenid.org/img_cenid/proyecto_catedra.png" 
                    alt="Proyecto Cátedra" 
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">Proyecto Cátedra</span>
              </div>
            </div>
          </div>

          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Proyectos
            </h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto">
              Iniciativas para la transformación educativa y el desarrollo sostenible
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        
        {/* Proyecto Principal */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-[#0077C8]">
            <div className="p-8">
              <h2 className="text-4xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Network className="w-10 h-10 text-[#0077C8]" />
                Encuentro Iberoamericano de Cátedras UNESCO y Redes UNITWIN
              </h2>
              
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-blue-50 to-sky-50 p-6 rounded-lg border-l-4 border-[#0077C8]">
                  <p className="text-lg text-gray-700 leading-relaxed">
                    Este evento en línea tiene el objetivo de <strong>movilizar la inteligencia colectiva y la experiencia de la red de la UNESCO</strong> de las Cátedras UNESCO y redes UNITWIN de Iberoamérica para intercambiar sobre cuestiones emergentes relacionadas con el <strong>desarrollo sostenible</strong>.
                  </p>
                </div>

                <div className="bg-white border-2 border-blue-200 rounded-lg p-6">
                  <p className="text-gray-700 leading-relaxed">
                    A través de debates interdisciplinarios y multidisciplinarios, el encuentro tiene como objetivo <strong>ampliar los límites del conocimiento</strong> sobre temas relacionados con el mandato de la UNESCO en educación, cultura, comunicación y ciencias, así como cuestiones más amplias para las Naciones Unidas.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {caracteristicasForo.map((caracteristica, index) => {
                    const IconComponent = caracteristica.icon;
                    return (
                      <div 
                        key={index}
                        className="bg-gradient-to-br from-blue-50 to-sky-50 border border-blue-200 rounded-lg p-5 hover:shadow-md transition-all"
                      >
                        <div className="bg-blue-100 p-3 rounded-lg w-fit mb-3">
                          <IconComponent className="w-6 h-6 text-[#0077C8]" />
                        </div>
                        <h3 className="font-bold text-gray-900 mb-2 text-sm">
                          {caracteristica.titulo}
                        </h3>
                        <p className="text-xs text-gray-700 leading-snug">
                          {caracteristica.descripcion}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Objetivos del Foro */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-blue-600">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Target className="w-8 h-8 text-blue-600" />
                Objetivos del encuentro
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {objetivosForo.map((objetivo, index) => (
                  <div 
                    key={index}
                    className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-5 hover:shadow-md transition-all"
                  >
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" />
                      <p className="text-gray-700 leading-relaxed">{objetivo}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Participantes */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-purple-600">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Users className="w-8 h-8 text-purple-600" />
                ¿Quiénes participan?
              </h2>
              
              <div className="mb-6 bg-gradient-to-r from-purple-50 to-indigo-50 p-6 rounded-lg border-l-4 border-purple-600">
                <p className="text-lg text-gray-700 leading-relaxed">
                  <strong>Abiertos al público</strong>, reúnen a la comunidad de Cátedras UNESCO y Redes UNITWIN, investigadores, representantes de la sociedad civil, profesionales y especialistas en una <strong>plataforma abierta para el debate, la colaboración y el intercambio de conocimientos</strong>, con miras a ampliar la cooperación para abordar las cuestiones acuciantes de nuestro tiempo.
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {tiposParticipantes.map((participante, index) => {
                  const IconComponent = participante.icon;
                  const colorClasses = {
                    blue: 'from-blue-50 to-blue-100 border-blue-300 text-blue-700',
                    purple: 'from-purple-50 to-purple-100 border-purple-300 text-purple-700',
                    green: 'from-green-50 to-green-100 border-green-300 text-green-700',
                    orange: 'from-orange-50 to-orange-100 border-orange-300 text-orange-700',
                    teal: 'from-teal-50 to-teal-100 border-teal-300 text-teal-700',
                    red: 'from-red-50 to-red-100 border-red-300 text-red-700'
                  };
                  
                  return (
                    <div 
                      key={index}
                      className={`bg-gradient-to-br ${colorClasses[participante.color]} border-2 rounded-lg p-4 text-center hover:shadow-lg transition-all`}
                    >
                      <IconComponent className="w-10 h-10 mx-auto mb-2" />
                      <p className="font-bold text-sm">{participante.tipo}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        {/* Formato del Evento */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-green-600">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Video className="w-8 h-8 text-green-600" />
                Formato del evento
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-300 rounded-lg p-6 text-center">
                  <Calendar className="w-12 h-12 text-green-600 mx-auto mb-4" />
                  <h3 className="font-bold text-lg text-gray-900 mb-2">Duración</h3>
                  <p className="text-gray-700">3 días de eventos</p>
                  <p className="text-sm text-green-700 font-semibold mt-2">7-9 de Mayo, 2025</p>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-300 rounded-lg p-6 text-center">
                  <Video className="w-12 h-12 text-blue-600 mx-auto mb-4" />
                  <h3 className="font-bold text-lg text-gray-900 mb-2">Modalidad</h3>
                  <p className="text-gray-700">Evento virtual</p>
                  <p className="text-sm text-blue-700 font-semibold mt-2">Transmisión por YouTube</p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 border-2 border-purple-300 rounded-lg p-6 text-center">
                  <Globe className="w-12 h-12 text-purple-600 mx-auto mb-4" />
                  <h3 className="font-bold text-lg text-gray-900 mb-2">Alcance</h3>
                  <p className="text-gray-700">Iberoamericano</p>
                  <p className="text-sm text-purple-700 font-semibold mt-2">Abierto al público</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resultados y Publicaciones */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-orange-600">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <FileText className="w-8 h-8 text-orange-600" />
                Resultados y publicaciones
              </h2>
              
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-6 rounded-lg border-l-4 border-orange-600">
                  <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    El encuentro genera conocimiento valioso que se documenta y difunde a través de diversas publicaciones especializadas.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white border-2 border-orange-200 rounded-lg p-6">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="bg-orange-100 p-3 rounded-lg">
                        <BookOpen className="w-8 h-8 text-orange-600" />
                      </div>
                      <div>
                        <h3 className="font-bold text-lg text-gray-900 mb-2">Publicaciones colectivas</h3>
                        <p className="text-gray-700 text-sm">
                          Documentación y difusión de la información especializada generada durante los encuentros
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white border-2 border-amber-200 rounded-lg p-6">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="bg-amber-100 p-3 rounded-lg">
                        <Award className="w-8 h-8 text-amber-600" />
                      </div>
                      <div>
                        <h3 className="font-bold text-lg text-gray-900 mb-2">Memorias académicas</h3>
                        <p className="text-gray-700 text-sm">
                          Compilación de ponencias, debates y conclusiones de los eventos realizados
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-orange-100 to-red-100 border-2 border-orange-300 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <TrendingUp className="w-6 h-6 text-orange-600" />
                    <h3 className="font-bold text-lg text-gray-900">Impacto esperado</h3>
                  </div>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start gap-2">
                      <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
                      <span>Fortalecimiento de redes de investigación iberoamericanas</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
                      <span>Desarrollo de proyectos colaborativos entre instituciones</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
                      <span>Contribución a los Objetivos de Desarrollo Sostenible</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
                      <span>Promoción del pensamiento crítico y la innovación educativa</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Próximos eventos */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg shadow-xl p-8">
            <div className="text-center mb-6">
              <Calendar className="w-16 h-16 mx-auto mb-4" />
              <h2 className="text-3xl font-bold mb-4">Próximos eventos 2025</h2>
              <p className="text-xl text-indigo-100">
                Calendario de actividades programadas
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-5">
                <h3 className="font-bold text-lg mb-2">Publicaciones colectivas</h3>
                <p className="text-sm text-indigo-100">Difusión de información especializada</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-5">
                <h3 className="font-bold text-lg mb-2">Postdoctorado en educación</h3>
                <p className="text-sm text-indigo-100">Programa Cátedras UNESCO</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-5">
                <h3 className="font-bold text-lg mb-2">Jornada de Conversatorios</h3>
                <p className="text-sm text-indigo-100">Educación de calidad</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-5">
                <h3 className="font-bold text-lg mb-2">Congreso virtual</h3>
                <p className="text-sm text-indigo-100">Análisis e Inclusión del Conocimiento</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-5 md:col-span-2 lg:col-span-2">
                <h3 className="font-bold text-lg mb-2">II Foro Iberoamericano</h3>
                <p className="text-sm text-indigo-100">Mayo 2026 - Siguiente edición del evento</p>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section>
          <div className="bg-gradient-to-r from-[#0077C8] to-[#005A9C] rounded-lg shadow-xl p-8 text-center text-white">
            <MessageSquare className="w-16 h-16 mx-auto mb-4" />
            <h2 className="text-3xl font-bold mb-4">Participa en nuestros proyectos</h2>
            <p className="text-xl mb-6 max-w-3xl mx-auto">
              Forma parte de la red iberoamericana comprometida con la transformación educativa
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/catedra-unesco/quienes-somos"
                className="inline-flex items-center gap-2 bg-white text-[#0077C8] px-8 py-4 rounded-lg font-bold text-lg hover:shadow-xl transform hover:scale-105 transition-all"
              >
                <Users className="w-6 h-6" />
                Conocer más sobre nosotros
              </Link>
              <Link 
                to="/catedra-unesco"
                className="inline-flex items-center gap-2 bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#0077C8] transition-all"
              >
                <ArrowRight className="w-6 h-6" />
                Volver al inicio
              </Link>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Proyectos;
